import type { RouteRecordRaw } from 'vue-router';
import { allDashboardRoutes } from '@/pages/dashboard/routes';

export const dashboardRoutes: RouteRecordRaw = {
  path: '',
  component: () => import('@/layouts/main.vue'),
  meta: {
    requireAuth: true,
    requireStoreId: true,
  },
  children: [
    ...allDashboardRoutes,
  ],
};
